import { Popover } from 'antd';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { ButtonPositionType, TPopover } from 'interfaces/betslip';
import { ConfirmationPopover } from 'components/Shared/ConfirmationPopover/ConfirmationPopover';

type TOddPopoverProps = PropsWithChildren & {
  visible: boolean;
  getButtonPosition: () => ButtonPositionType;
  hidePopover: () => void;
  popover?: TPopover;
};

export const OddPopover = ({
  children,
  popover,
  hidePopover,
  visible,
  getButtonPosition
}: TOddPopoverProps) => {
  return (
    <Popover
      content={<ConfirmationPopover {...(popover || {})} />}
      placement={getButtonPosition()}
      trigger="click"
      visible={visible}
      onVisibleChange={visible => !visible && hidePopover()}
      overlayClassName={cc([
        'quick-bet-confirmation-popover',
        {
          'quick-bet-confirmation-popover-right':
            isMobile() && getButtonPosition() === 'topRight',
          'quick-bet-confirmation-popover-hide': popover?.validateRecaptcha
        }
      ])}
      destroyTooltipOnHide
      {...(isMobile()
        ? {
            getPopupContainer: () =>
              document.querySelector('.advancedMatchCardInLineWrapper') ||
              document.querySelector('.single-game-markets') ||
              document.querySelector('.markets__body-container') ||
              document.body
          }
        : {})}
    >
      {children}
    </Popover>
  );
};
